import React from 'react';
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tabs,
    Tab,
    Typography,

} from "@material-ui/core";
import useStyles from '../styles/styles';
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter';
import {base16AteliersulphurpoolLight} from 'react-syntax-highlighter/dist/esm/styles/prism';
import {addDays, format} from 'date-fns';

const OfferEventApiPostingInstructions = () => {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [codeTab, setCodeTab] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleCodeTab = (event, newValue) => {
        setCodeTab(newValue);
    };


    const sourceKeyUrl = (new URL(window.location)).searchParams.get("sourceKey");

    const sourceKeySet = sourceKeyUrl ? true : false;

    const sourceKey = sourceKeySet ? sourceKeyUrl : 'XXXXXXXX-XYXX-XXXX-XXXX-XXXXXXXXXXXX';

    const testUrl = "https://test-api.acquireinteractive.com/offer/event/cdc";
    const prodUrl = "https://api.acquireinteractive.com/offer/event/cdc";

    function TabPanel(props) {
        const { children, value, value2, index, ...other } = props;

        return (
            <Typography
                component="div"
                role="tabpanel"
                hidden={value !== index}
                id={`wrapped-tabpanel-${index}`}
                aria-labelledby={`wrapped-tab-${index}`}
                {...other}
            >
                {value === index && <Box p={3} pt={1}>{children}</Box>}
            </Typography>
        );
    }

    function TabPanel2(props) {
        const {children, value, index, ...other} = props;

        return (
            <Typography
                component="div"
                role="tabpanel"
                hidden={value !== index}
                id={`wrapped-tabpanel-${index}`}
                aria-labelledby={`wrapped-tab-${index}`}
                {...other}
            >
                {value === index && <Box p={3} pt={1}>{children}</Box>}
            </Typography>
        );
    }

    const exampleData = [
        {key: "source_key", value: sourceKey},
        {key: "event_type", value: "PAGE_VIEW"},
        {key: "source_lead_id", value: "123456"},
        {key: "client_ip_address", value: "127.0.0.1"},
        {key: "user_agent", value: "Mozilla/5.0 (Macintosh; Intel Mac OS X x.y; rv:42.0)"},
        {key: "referring_site_url", value: "https://www.testsite.com"},
        {key: "source_sub_code_1", value: "abc"},
        {key: "source_sub_code_2", value: "123"},
        {key: "zip", value: "89144"},
        {key: "timestamp", value: "1681228921640"}
    ]

    const formatDataPhpAndNode = (exampleData, tabs) => {
        return exampleData.map(data => `${tabs}"${data.key}": "${data.value}"`).join(",\n")
    }

    const formatDataJavaCSharp = (exampleData, tabs) => {
        return exampleData.map(data => `\\"${data.key}\\": \\"${data.value}\\"," +`).join(`\n${tabs}"`).slice(0, -4)
    }

    const formatDataCurl = (exampleData, tabs) => {
        return exampleData.map(data => `${tabs}\\"${data.key}\\": \\"${data.value}\\"`).join(`,\n`)
    }

    const formatDataPython = (exampleData, tabs) => {
        return exampleData.map(data => `${tabs}'${data.key}': '${data.value}'`).join(`,\n`)
    }

    return (
        <>
            <Typography variant="h2" gutterBottom>
                Offer Event API Posting Instructions
            </Typography>
            <Typography variant="body1">
                <p>
                    Acquire Interactive provides their customers with an offer event API that allows affiliates to post
                    events details into our system for tracking and conversion. To achieve this you will need to post a JSON payload into our REST endpoint.
                </p>
            </Typography>

            <Paper className={`${classes.paper} ${classes.autoWidth}`}>
                <Table className={`${classes.table} ${classes.marginAuto}`}  size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell variant="head">Endpoint</TableCell>
                            <TableCell variant="head">Address</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>Test</TableCell>
                            <TableCell>{testUrl}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Production</TableCell>
                            <TableCell>{prodUrl}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>

            <Typography variant="body1">
                {sourceKeySet ? (
                    <p> The JSON payload will also include a "Source Key" that identifies the source of your leads and ensures you are paid for conversions, your source key is "{sourceKey}".</p>
                ) : null}

            </Typography>
            <Paper className={classes.paper}>
                <Table className={classes.table} size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell variant="head">Field&nbsp;Name</TableCell>
                            <TableCell variant="head">Data&nbsp;Type</TableCell>
                            <TableCell variant="head">Required</TableCell>
                            <TableCell variant="head">Example</TableCell>
                            <TableCell variant="head">Notes</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>source_key</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>{sourceKey}</TableCell>
                            <TableCell>Required, the traffic source identifier provided by Acquire
                                Interactive</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>event_type</TableCell>
                            <TableCell>Enum</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>PAGE_VIEW</TableCell>
                            <TableCell>Required, see below for possible entries.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>source_lead_id</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>abc123</TableCell>
                            <TableCell>Your lead identifier you would like to associate with this request, maximum number of characters accepted is 32.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>client_ip_address</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>192.168.0.1</TableCell>
                            <TableCell>Required, IPV4 or IPV6 address of the customer.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>user_agent</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>Mozilla/5.0 (Macintosh; Intel Mac OS X...</TableCell>
                            <TableCell>Required, the user agent of the customer. Must be between 1 and 150 characters.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>source_sub_code_1</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>abc123</TableCell>
                            <TableCell>
                                The traffic source (affiliate, organic, google, bing, etc.).
                                The value may be coded, ie. you may use any value to represent 'google' such as '100' or 'kdjf' but keep it consistent.
                                Values should not be unique - you can track your unique internal identifier within the 'source_lead_id' field.
                                Maximum number of characters accepted is 32.
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>source_sub_code_2</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>123abc</TableCell>
                            <TableCell>
                                The traffic "campaign" (affiliate name, ppc keywords, mailing identifier, website name, etc.).
                                The value may be coded, ie. you may use any value to represent 'affiliate' such as '123abc' or 'fndfh1' but keep it consistent.
                                Values should not be unique - you can track your unique internal identifier within the 'source_lead_id' field.
                                Maximum number of characters accepted is 32.
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>zip</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>66102</TableCell>
                            <TableCell>
                                Send either the 5 digit ZIP Code or the 10 digit ZIP+4 with the dash in it.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>amount</TableCell>
                            <TableCell>Decimal</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>1.00</TableCell>
                            <TableCell>The amount billed.
                                Omit this field or use null when event type is not CONVERSION.
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>timestamp</TableCell>
                            <TableCell>Long</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>1681228921640</TableCell>
                            <TableCell>The timestamp of the event in epoch milliseconds.
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>

            <Typography  variant="h4" align="left">
                Event Type Enum Values
            </Typography>

            <Paper className={classes.paper}>
                <Table className={classes.table} size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell variant="head">Value</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>PAGE_VIEW</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>CONVERSION</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>FORM_SUBMIT</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>

            <Typography variant="h4" align="left">
                JSON Samples
            </Typography>
            <Paper className={classes.paper}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    <Tab label="Request"/>
                    <Tab label="Conversion Request"/>
                    <Tab label="Response"/>
                </Tabs>

                <TabPanel2 value={value} index={0}>
                    <SyntaxHighlighter language="php" style={base16AteliersulphurpoolLight}>
                        {
                            `
{
  "source_key": "` + sourceKey + `",
  "event_type": "PAGE_VIEW",
  "source_lead_id": "123456",
  "client_ip_address": "127.0.0.1",
  "user_agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X x.y; rv:42.0)",
  "referring_site_url": "https://www.testsite.com",
  "source_sub_code_1": "abc",
  "source_sub_code_2": "123",
  "zip": "89144",
  "timestamp": "1681228921640"
}`}
                    </SyntaxHighlighter>
                </TabPanel2>
                <TabPanel2 value={value} index={1}>
                    <SyntaxHighlighter language="javascript" style={base16AteliersulphurpoolLight}>
                        {
                            `
{
  "source_key": "` + sourceKey + `",
  "event_type": "CONVERSION",
  "source_lead_id": "123456",
  "client_ip_address": "127.0.0.1",
  "user_agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X x.y; rv:42.0)",
  "referring_site_url": "https://www.testsite.com",
  "source_sub_code_1": "abc",
  "source_sub_code_2": "123",
  "zip": "89144",
  "amount": 1.00,
  "timestamp": "1681228921640"
}
`}
                    </SyntaxHighlighter>
                </TabPanel2>
                <TabPanel2 value={value} index={2}>
                    <SyntaxHighlighter language="php" style={base16AteliersulphurpoolLight}>
                        {
                            `
{
  "request_id": "` + sourceKey + `",
  "request_received": "2023-03-30T22:18:22.328Z",
  "response_rendered": "2023-03-30T22:18:22.474Z",
  "response_time": 0.146,
  "status": "SUCCESS",
  "redirect_url": null,
  "messages": null,
  "validation_errors": null,
  "timestamp": "1681228921640"
}
`}
                    </SyntaxHighlighter>
                </TabPanel2>

            </Paper>


            <Typography variant="h4" align="left">
                Code Samples
            </Typography>
            <Paper className={classes.paper}>
                <Tabs
                    value={codeTab}
                    onChange={handleCodeTab}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    <Tab label="PHP"/>
                    <Tab label="Node"/>
                    <Tab label="Java"/>
                    <Tab label="C#"/>
                    <Tab label="Curl"/>
                    <Tab label="Python"/>
                </Tabs>

                <TabPanel value={codeTab} index={0}>
                    <SyntaxHighlighter language="php" style={base16AteliersulphurpoolLight}>
                        {
                            `<?php

$curl = curl_init();

curl_setopt_array($curl, array(
    CURLOPT_URL => "${testUrl}",
    CURLOPT_RETURNTRANSFER => true,
    CURLOPT_ENCODING => "",
    CURLOPT_MAXREDIRS => 10,
    CURLOPT_TIMEOUT => 0,
    CURLOPT_FOLLOWLOCATION => false,
    CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
    CURLOPT_CUSTOMREQUEST => "POST",
    CURLOPT_POSTFIELDS => <<<EOT
    {
${formatDataPhpAndNode(exampleData, "\t\t")}
    }
EOT
    ,CURLOPT_HTTPHEADER => array(
        "Content-Type: application/json"
    )
));

$response = curl_exec($curl);
$err = curl_error($curl);

curl_close($curl);

if ($err) {
    echo "cURL Error #:" . $err;
} else {
    echo $response;
} ?>
                        `}
                    </SyntaxHighlighter>
                </TabPanel>
                <TabPanel value={codeTab} index={1}>
                    <SyntaxHighlighter language="javascript" style={base16AteliersulphurpoolLight}>
                        {`
var postData =  \`{
${formatDataPhpAndNode(exampleData, "\t")}
}\`;

var https = require('https');

var options = {
    'host': 'test-api.acquireinteractive.com',
    'method': 'POST',
    'path': '/offer/event/cdc/',
    'headers': {
        'Content-Type': 'application/json',
        'Content-Length': postData.length
    }
};

var req = https.request(options, function (res) {
    var chunks = [];

    res.on("data", function (chunk) {
        chunks.push(chunk);
    });

    res.on("end", function (chunk) {
        var body = Buffer.concat(chunks);
        console.log(body.toString());
    });

    res.on("error", function (error) {
        console.error(error);
    });
});

req.write(postData);

req.end();
                        `}
                    </SyntaxHighlighter>
                </TabPanel>
                <TabPanel value={codeTab} index={2}>
                    <SyntaxHighlighter language="java" style={base16AteliersulphurpoolLight}>
                        {
                            `/*
* To following code is used to create a POST Web request with appropriate information and send it, recieve the response and display the response received.
* In order to execute the code, create a command line app and place the code in the Main() method and run the application to execute the code.
*/ 
try {
    URL a = new URL("${testUrl}");

    HttpURLConnection urlCon = (HttpURLConnection) a.openConnection();

    urlCon.setRequestMethod("POST");

    urlCon.setRequestProperty("Content-Type", "application/json");

    urlCon.setDoOutput(true);

    String json = "{${formatDataJavaCSharp(exampleData, "\t\t\t\t\t")}}";

    try (OutputStream os = urlCon.getOutputStream()) {
        byte[] input = json.getBytes("utf-8");
        os.write(input, 0, input.length);
        }

    if (urlCon.getResponseCode() < HttpURLConnection.HTTP_BAD_REQUEST) {
        try (BufferedReader br = new BufferedReader(
            new InputStreamReader(urlCon.getInputStream(), "utf-8"))) {
                StringBuilder response = new StringBuilder();
                String responseLine = null;
                while ((responseLine = br.readLine()) != null) {
                    response.append(responseLine.trim());
                }
                System.out.println(response.toString());
            }
        }
    else {
        try (BufferedReader br = new BufferedReader(
            new InputStreamReader(urlCon.getErrorStream(), "utf-8"))) {
                StringBuilder response = new StringBuilder();
                String responseLine = null;
                while ((responseLine = br.readLine()) != null) {
                    response.append(responseLine.trim());
                }
                System.out.println(response.toString());
            }
        }
    }
catch (MalformedURLException e) {
            e.printStackTrace();
        }
catch (IOException e) {
            e.printStackTrace();
}`}
                    </SyntaxHighlighter>
                </TabPanel>
                <TabPanel value={codeTab} index={3}>
                    <SyntaxHighlighter language="c#" style={base16AteliersulphurpoolLight}>
                        {
                            `/*
* To following code is used to create a POST Web request with appropriate information and send it, recieve the response and display the response received.
* In order to execute the code, create a blank console application and place the code in the Main() method and run the application to execute the code.
*/ 
Console.WriteLine("\\nCreating Request....");
HttpWebRequest httpWebRequest = (HttpWebRequest)WebRequest.Create("${testUrl}");
httpWebRequest.ContentType = "application/json";
httpWebRequest.Method = "POST";

using (var streamWriter = new StreamWriter(httpWebRequest.GetRequestStream()))
{
    string json = "{${formatDataJavaCSharp(exampleData, "\t\t\t\t\t")}}";
                                  
    streamWriter.Write(json);

}
Console.WriteLine("\\nRequest Created....");
Console.WriteLine("\\nSeding Request....");

try
{
    var httpResponse = (HttpWebResponse)httpWebRequest.GetResponse();

    using (var streamReader = new StreamReader(httpResponse.GetResponseStream()))
    {
        var result = streamReader.ReadToEnd();
        Console.WriteLine("\\nResponse received: " + result);
        Console.ReadLine();
    }
}
catch (WebException e)
{
    using (WebResponse response = e.Response)
    {
        using (Stream data = response.GetResponseStream())
        {
            StreamReader sr = new StreamReader(data);
            Console.WriteLine("\\nErred Response received: " + sr.ReadToEnd());
            Console.ReadLine();
        }
    }
}
   `}
                    </SyntaxHighlighter>
                </TabPanel>
                <TabPanel value={codeTab} index={4}>
                    <SyntaxHighlighter language="bash" style={base16AteliersulphurpoolLight}>
                        {`
curl --location --request POST "${testUrl}" \\
    --header "Content-Type: application/json" \\
    --data "{
${formatDataCurl(exampleData, '\t\t\t')}
        }"
                            `}
                    </SyntaxHighlighter>
                </TabPanel>
                <TabPanel value={codeTab} index={5}>
                    <SyntaxHighlighter language="python" style={base16AteliersulphurpoolLight}>
                        {`
import requests

url = "${testUrl}"
data = {
${formatDataPython(exampleData, '\t\t')}
        }

headers = {'Content-Type': 'application/json'}
try:
    r = requests.post(url, data=data, headers=headers)
    r.raise_for_status()
    print(r.text)
except requests.exceptions.HTTPError as errh:
    print ("Http Error:",errh)
except requests.exceptions.ConnectionError as errc:
    print ("Error Connecting:",errc)
except requests.exceptions.Timeout as errt:
    print ("Timeout Error:",errt)
except requests.exceptions.RequestException as err:
    print ("Oops: Something Else",err)
                        `}
                    </SyntaxHighlighter>
                </TabPanel>
            </Paper>

        </>
    );
};

export default OfferEventApiPostingInstructions
